import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { SelectListV2Component } from './select-list-v2.component';

@NgModule({
    declarations: [SelectListV2Component],
    imports: [CommonModule, ReactiveFormsModule, OverlayModule, PortalModule, MatIconModule, TranslateModule],
    exports: [SelectListV2Component],
})
export class SelectListV2Module {}
